import React, { createContext } from "react";
import { Navigate } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import { useUserContext, UserProvider } from "shared/contexts/UserContext";

export const UserContext = createContext(null);

function ProtectedRoute({ children }) {
    const { user, loading, isValidating, isAuthenticated, error } = useUserContext();

    // Show loading spinner during initial load OR while revalidating after login
    // (navigate("/") can be called before the SWR state update propagates to this component)
    if (loading || (!user && isValidating)) {
        return (
            <Box 
                display="flex" 
                justifyContent="center" 
                alignItems="center" 
                minHeight="100vh"
            >
                <CircularProgress />
            </Box>
        );
    }

    // Redirect to login if not authenticated or auth error (401/403)
    if (!isAuthenticated || !user || error?.status === 401 || error?.status === 403) {
        return <Navigate to="/login/" replace />;
    }

    return children;
}

export default ProtectedRoute;

// Admin pages: staff or superusers (the same rule as the backend's IsAdminOrSuperuser).
// The server enforces it; this only keeps members away from pages that would stay empty.
export function AdminRoute({ children }) {
    const { user, loading, isValidating, isAuthenticated, error } = useUserContext();

    if (loading || (!user && isValidating)) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    if (!isAuthenticated || !user || error?.status === 401 || error?.status === 403) {
        return <Navigate to="/login/" replace />;
    }

    if (!user.is_superuser && !user.is_staff) {
        return <Navigate to="/" replace />;
    }

    return children;
}

export function SuperuserRoute({ children }) {
    const { user, loading, isValidating, isAuthenticated, error } = useUserContext();

    if (loading || (!user && isValidating)) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    if (!isAuthenticated || !user || error?.status === 401 || error?.status === 403) {
        return <Navigate to="/login/" replace />;
    }

    if (!user.is_superuser) {
        return <Navigate to="/" replace />;
    }

    return children;
}



// import { Navigate } from "react-router-dom";
// import { useAuth } from "./useAuth";

// const ProtectedRoute = ({ children }) => {
//   const { isAuthenticated, loading } = useAuth();

//   if (loading) {
//     return null; // or spinner
//   }

//   return isAuthenticated ? children : <Navigate to="/login" replace />;
// };

// export default ProtectedRoute;
